import { AlarmItem } from '@/types';
import { AlarmFeedRow } from './AlarmFeedRow';

export interface AlarmFeedListProps {
  alarms: AlarmItem[];
  emptyLabel?: string;
}

/** Vertical list of AlarmFeedRow — used inside a SectionPanel wherever a short alarm feed is shown. */
export function AlarmFeedList({ alarms, emptyLabel = 'No alarms.' }: AlarmFeedListProps) {
  if (alarms.length === 0) {
    return <p className="py-4 text-center text-sm text-text-secondary">{emptyLabel}</p>;
  }

  return (
    <div>
      {alarms.map((alarm) => (
        <AlarmFeedRow key={alarm.id} alarm={alarm} />
      ))}
    </div>
  );
}
